import { render, staticRenderFns } from "./contactsList.vue?vue&type=template&id=b12d2e9c&scoped=true&"
import script from "./contactsList.vue?vue&type=script&lang=js&"
export * from "./contactsList.vue?vue&type=script&lang=js&"
import style0 from "./contactsList.vue?vue&type=style&index=0&id=b12d2e9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12d2e9c",
  null
  
)

export default component.exports